<template>
  <div v-if="items" :data-refapp-tagging-id="taggingId" class="ra-banner__multiple">
    <div :class="`ra-banner__multiple-heading text--${alignment}`">
      <component :is="heading" v-if="title">{{ title }}</component>
      <p v-if="description">{{ description }}</p>
    </div>
    <div class="ra-banner__multiple-content-wrap">
      <ul
        :id="taggingId"
        ref="list"
        class="ra-banner__multiple-list scroll scroll-x scrollbar--disabled"
        @scroll="updateSliderThumbPosition"
        @scrollend="isScrolling = false"
      >
        <li v-for="(item, i) in items" :key="i" class="ra-banner__multiple-item">
          <component
            :is="item.cta.href ? 'a' : 'div'"
            v-if="item.cta"
            :href="item.cta.href"
            class="ra-banner__multiple-item__link"
            :data-refapp-tagging-target="item.cta.href ? item.taggingTarget : undefined"
          >
            <div
              :class="[
                'ra-banner__multiple-item__image-container scrim',
                `shape--${shape}`,
                item.type,
                item.cta.href && 'scrim--clickable',
              ]"
            >
              <img
                v-if="item.image?.src"
                :src="item.image.src"
                :alt="item.image.alt"
                class="ra-banner__multiple-item__image"
                width="100%"
                height="100%"
              />
              <div v-if="item.cta.text" class="ra-banner__multiple-item__image-title">
                {{ item.cta.text }}
              </div>
            </div>
            <div
              v-if="item.caption"
              :class="['ra-banner__multiple-item__caption', `text--${alignCaption}`]"
              v-html="item.caption"
            ></div>
          </component>
        </li>
      </ul>
      <div
        v-if="showScrollbar"
        class="ra-banner__multiple-scrollbar"
        role="scrollbar"
        :aria-valuenow="step"
        :aria-controls="taggingId"
        aria-orientation="horizontal"
      >
        <input
          v-model="step"
          aria-label="custom scrollbar"
          type="range"
          value="0"
          :max="maxRangeValue"
          step="any"
          @input="scrollList"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'refapp-banner-base-multiple',
  inject: [
    'items',
    'taggingId',
    'alignment',
    'title',
    'description',
    'heading',
    'shape',
    'alignCaption',
  ],
  data() {
    return {
      scrollUnitWidth: 0,
      showScrollbar: false,
      isScrolling: false,
      step: 0,
      maxRangeValue: 1000,
    };
  },
  mounted() {
    const { list } = this.$refs;
    if (!list) return;

    this.ro = new ResizeObserver(() => {
      this.showScrollbar = list.scrollWidth > list.offsetWidth;
      /**
       * @member The width to scroll (in pixels) equivalent to
       * 1(one) range input step.
       *
       * Divides the scrollable width (the part of the container that's hidden) by
       * the max of the range input.
       */
      this.scrollUnitWidth = (list.scrollWidth - list.offsetWidth) / this.maxRangeValue;
    });

    this.ro.observe(list);
  },
  beforeUnmount() {
    // Despite the low odds of this component ever unmounting in a page's lifecycle, observers
    // should always be cleaned up to prevent undesirable situations
    this.ro.disconnect();
  },
  methods: {
    /**
     * Sets the slider thumb position (the one users can grab with the mouse) based on the
     * scrolled amount of the list ()
     * @param {Object} e The scroll event emitted by the list.
     */
    updateSliderThumbPosition(e) {
      // Do not programatically update slider thumb when the scrollbar is in use.
      if (this.isScrolling) return;
      const step = e.target.scrollLeft / this.scrollUnitWidth;
      this.step = step;
    },
    /**
     * Scrolls the list(using its $ref) according to the value of the range input.
     * @param {Object} e The input event emitted by the range input.
     */
    scrollList(e) {
      this.isScrolling = true;
      this.$refs.list.scrollTo(this.scrollUnitWidth * parseInt(e.target.value, 10), 0);
    },
  },
};
</script>
